/**
 * Manage company site pages
 */
import Ajax from '@/lib/ajax_wrapper'

function mailchimpPath(companyId, siteId) {
  return `/admin/companies/${companyId}/sites/${siteId}/mailchimp`
}

/**
 * Create a company site mailchimp
 *
 * only one per site
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {object} mailchimp
 * @param {string} mailchimp.mailchimp_user_id
 * @param {string} mailchimp.mailchimp_url
 * @param {string} mailchimp.mailchimp_list_id
 * @param {boolean} mailchimp.popup
 * @param {string} mailchimp.heading
 *
 * @returns {promise}
 */
export function createCompanySiteMailchimpData(companyId, siteId, mailchimp) {
  return Ajax.request({
    url: mailchimpPath(companyId, siteId),
    method: 'POST',
    data: {mailchimp}
  })
}

/**
 * Read a company site mailchimp
 *
 * @param {string} companyId
 * @param {string} siteId
 *
 * @returns {promise}
 */
export function readCompanySiteMailchimpData(companyId, siteId) {
  return Ajax.request({
    url: mailchimpPath(companyId, siteId)
  })
}

/**
 * Update a company site mailchimp
 *
 * @param {string} companyId
 * @param {string} siteId
 * @param {object} mailchimp
 * @param {string} mailchimp.mailchimp_user_id
 * @param {string} mailchimp.mailchimp_url
 * @param {string} mailchimp.mailchimp_list_id
 * @param {boolean} mailchimp.popup
 * @param {string} mailchimp.heading
 *
 * @returns {promise}
 */
export function updateCompanySiteMailchimpData(companyId, siteId, mailchimp) {
  return Ajax.request({
    url: mailchimpPath(companyId, siteId),
    method: 'PATCH',
    data: {mailchimp}
  })
}

/**
 * Delete a company site mailchimp
 *
 * @param {string} companyId
 * @param {string} siteId
 *
 * @returns {promise}
 */
export function deleteCompanySiteMailchimpData(companyId, siteId) {
  return Ajax.request({
    url: mailchimpPath(companyId, siteId),
    method: 'DELETE'
  })
}
